<div class="item__text-box">
  <div class="wrapper">
    <tui-icon
      *ngIf="!!item?.externalTypeCode"
      class="icon"
      [icon]="APP_CONFIG.dictionaries.externalTypeIdIcon"
    ></tui-icon>
    <div class="texts">
      <div class="item__title item__title_line item__title_line_2">{{ item?.name }}</div>
    </div>
  </div>
</div>
